<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user?.profile_image_name"
            [src]="user?.profile_image_name">
        <mat-icon
            *ngIf="!showAvatar || !user?.profile_image_name"
            [svgIcon]="'heroicons_outline:user-circle'" class="text-primary hover:text-magenta"></mat-icon>
        <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
            [ngClass]="{'mr-px mb-px': !showAvatar || !user?.profile_image_name,
                          'bg-green-500': user?.status === 'online',
                          'bg-amber-500': user?.status === 'away',
                          'bg-red-500': user?.status === 'busy',
                          'bg-gray-400': user?.status === 'not-visible'}"
        ></span>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item (click)="userdetail(user.id)">
        <!-- <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon> -->
        <span>{{user?.userName}}</span>
        <!-- <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{user?.userName}}</span>
        </span> -->
    </button>
    
    <button
    mat-menu-item
    (click)=" changepassword()">
    <!-- <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon> -->
    <span>Change Password</span>
    </button>
     <!-- <button
    mat-menu-item
    (click)=" activityLog()">

    <span>Activity Log</span>
    </button> -->
    
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <!-- <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon> -->
        <span>Sign out</span>
    </button>
</mat-menu>


